import React, { useEffect, useState } from 'react';
import { apiService } from '../services/api';

/** Header chip: role only (Primary / Secondary). */
export function GatewayRoleBadge({ onRole }: { onRole?: (role: string) => void }) {
  const [role, setRole] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const data = await apiService.getSyncStatus();
        if (!cancelled) {
          setRole(data.role);
          onRole?.(data.role);
        }
      } catch {
        if (!cancelled) setRole(null);
      }
    };
    load();
    const id = window.setInterval(load, 30000);
    return () => {
      cancelled = true;
      window.clearInterval(id);
    };
  }, [onRole]);

  if (!role) return null;
  const label = role === 'secondary' ? 'Secondary' : 'Primary';
  const className =
    role === 'secondary' ? 'sync-badge sync-secondary' : 'sync-badge sync-ok';

  return <div className={className}>{label}</div>;
}
